<template>
	<div :class="classes">
		<TeamListHeaderCard
			class-name="team-list__header"
		/>
		<TeamingScroller
			class-name="team-list__teaming-scroller"
			:items="teams"
			:item-size="itemSize"
			@scrollThresholdReached="$emit( `more` )"
		>
			<template v-slot:default="{ item: team }">
				<TeamListSkeletonCard v-if="team.skeleton" />
				<TeamListCard
					v-else
					class-name="team-list__card"
					:team="team"
					v-on="bubble( `favorite`, `unfavorite`, `navTo` )"
				/>
			</template>
		</TeamingScroller>
	</div>
</template>

<script>
import ScreenSizeDetector from "screen-size-detector";
import EventsMixin from "../../mixins/EventsMixin";
import EnumsMixin from "../../mixins/EnumsMixin";
import TeamListCard from "./TeamListCard";
import TeamListHeaderCard from "./TeamListHeaderCard";
import TeamListSkeletonCard from "./TeamListSkeletonCard";
import TeamingScroller from "../TeamingScroller";

export default {
	name: "TeamList",
	mixins: [ EventsMixin, EnumsMixin, ],
	components: {
		TeamListCard,
		TeamListHeaderCard,
		TeamingScroller,
		TeamListSkeletonCard,
	},
	emits: [
		"favorite",
		"unfavorite",
		"navTo",
		"more",
	],
	data() {
		return {
			screenWidth: window.innerWidth,
		};
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		teams: {
			type: Array,
			required: true,
		},
	},
	computed: {
		classes() {
			return {
				"team-list": true,
				[ this.className ]: !!this.className,
			};
		},
		itemSize() {
			return this.isAtExtraSmallBreakpoint ? 112 : 76; // eslint-disable-line no-magic-numbers
		},
		isAtExtraSmallBreakpoint() {
			return this.screenWidth <= this.enums.BreakpointSize.XS;
		},
	},
	created() {
		this.screen = new ScreenSizeDetector( {
			onWidthChange: () => {
				this.screenWidth = this.screen.width;
			},
		} );
	},
	unmounted() {
		this.screen.removeMainCallback( "widthchange" );
		this.screen = undefined;
	},
};
</script>

<style lang="scss" scoped>
.team-list__header {
	display: none;
	margin-bottom: 1rem;

	@include for-size('md') {
		display: flex;
	}
}

.team-list__card {
	margin-bottom: 1rem;
}
</style>

<style lang="scss">
.team-list__teaming-scroller.ready {
	padding-bottom: 5rem !important;

	@include for-size('sm') {
		padding-bottom: 6.5rem !important;
	}

	@include for-size('md') {
		padding-bottom: 9rem !important;
	}
}
</style>
